class NasheCollectionSwatches {
  constructor(root) {
    this.root = root;
    this.image = root.querySelector("[data-nashe-card-primary-image]");
    this.links = root.querySelectorAll("[data-nashe-card-link]");
    this.buttons = root.querySelectorAll("[data-nashe-card-swatch]");
    this.addToCartButton = root.querySelector("[data-add-to-cart]");

    if (!this.image || this.buttons.length === 0 || root.dataset.nasheSwatchesBound === "true") return;
    root.dataset.nasheSwatchesBound = "true";

    this.buttons.forEach((button) => {
      button.addEventListener("click", () => this.select(button));
    });
  }

  select(button) {
    const imageSrc = button.dataset.nasheImageSrc;
    const imageSrcset = button.dataset.nasheImageSrcset;
    const imageAlt = button.dataset.nasheImageAlt;
    const variantUrl = button.dataset.nasheVariantUrl;
    const variantId = button.dataset.nasheVariantId;

    if (imageSrc) this.image.src = imageSrc;
    if (imageSrcset) this.image.srcset = imageSrcset;
    if (imageAlt) this.image.alt = imageAlt;
    if (variantId) this.root.dataset.nasheVariantId = variantId;
    if (variantId && this.addToCartButton) this.addToCartButton.dataset.variantId = variantId;
    if (variantUrl) {
      this.links.forEach((link) => {
        link.href = variantUrl;
      });
    }

    this.buttons.forEach((swatch) => {
      swatch.classList.toggle("is-active", swatch === button);
      swatch.setAttribute("aria-pressed", swatch === button ? "true" : "false");
    });
  }
}

function initNasheCollectionSwatches(scope = document) {
  scope.querySelectorAll("[data-nashe-card-swatches]").forEach((root) => {
    new NasheCollectionSwatches(root);
  });
}

initNasheCollectionSwatches();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches("[data-nashe-card-swatches]")) new NasheCollectionSwatches(node);
      initNasheCollectionSwatches(node);
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
